import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const subs = new Set();
let value = null, pending = null;

export const setChannel = (v) => { value = v || ""; subs.forEach((fn) => fn(value)); };

export function useChannel() {
  const [link, setLink] = useState(value || "");
  useEffect(() => {
    subs.add(setLink);
    if (value === null) {
      pending = pending || axios.get(`${API}/settings/office`).then((r) => setChannel(r.data.whatsapp_channel)).catch(() => { pending = null; });
    } else setLink(value);
    return () => subs.delete(setLink);
  }, []);
  return link;
}
